'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.37919 2.42544C5.81126 1.9229 6.56891 1.86578 7.07144 2.29786L17.6113 11.3599C17.6231 11.3701 17.6351 11.3804 17.6473 11.3908C17.8192 11.5384 18.0321 11.7211 18.1922 11.9037C18.3861 12.1246 18.644 12.499 18.644 13.0281C18.644 13.5572 18.3861 13.9316 18.1922 14.1526C18.0321 14.3351 17.8192 14.5178 17.6473 14.6654C17.6351 14.6759 17.6231 14.6862 17.6113 14.6963L7.16191 23.6808C6.65938 24.1129 5.90173 24.0557 5.46966 23.5532C5.03758 23.0507 5.09469 22.293 5.59722 21.861L15.8703 13.0281L5.50676 4.11769C5.00423 3.68562 4.94711 2.92797 5.37919 2.42544Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
